import { useAvailableProjects } from './useAvailableProjects.js';
import { useAuth } from '../../lib/firebase/auth-context.js';

interface Props {
  value: string | undefined;
  onChange: (next: string | undefined) => void;
}

/**
 * 投稿フォーム共通の「プロジェクト（任意）」セレクタ。
 * shared + own private の merge を提示。空選択で紐付けなし。
 *
 * private project 表示は「（自分のみ）」サフィックスで識別。マスタ取得失敗時は
 * 「（読込失敗）」表示で送信は阻害しない（任意フィールドのため）。
 */
export function ProjectSelectField({ value, onChange }: Props) {
  const { fbUser } = useAuth();
  const projectsQ = useAvailableProjects(fbUser?.uid);

  return (
    <label className="auth-field">
      <span>
        トピック <em className="mono">任意</em>
      </span>
      <select
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value || undefined)}
        disabled={projectsQ.isPending}
      >
        <option value="">（紐付けなし）</option>
        {(projectsQ.data ?? []).map((p) => (
          <option key={p.id} value={p.id}>
            {p.name}
            {p.visibility === 'private' ? '（自分のみ）' : ''}
          </option>
        ))}
      </select>
      {projectsQ.isError && (
        <span className="mono" style={{ fontSize: 10, color: 'var(--ink-4)' }}>
          トピック一覧の読込に失敗しました（紐付けなしで投稿可能）
        </span>
      )}
    </label>
  );
}
